(function () {
  var body = document.body;

  function openDrawer() { body.classList.add('drawer-open'); }
  function closeDrawer() { body.classList.remove('drawer-open'); }

  function refreshCart(open) {
    return fetch('/?sections=cart-drawer,header')
      .then(function (r) { return r.json(); })
      .then(function (s) {
        var parser = new DOMParser();
        ['cart-drawer', 'header'].forEach(function (id) {
          var current = document.getElementById('shopify-section-' + id);
          if (!current || !s[id]) return;
          var next = parser.parseFromString(s[id], 'text/html').getElementById('shopify-section-' + id);
          if (next) current.innerHTML = next.innerHTML;
        });
        if (open) openDrawer();
      });
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-cart-open],[data-cart-close],[data-line],[data-qty-step]');
    if (!t) return;

    if (t.hasAttribute('data-cart-open')) {
      if (document.getElementById('cart-drawer')) { e.preventDefault(); openDrawer(); }
      return;
    }
    if (t.hasAttribute('data-cart-close')) { closeDrawer(); return; }

    if (t.hasAttribute('data-line')) {
      e.preventDefault();
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: Number(t.dataset.line), quantity: Number(t.dataset.qty) })
      }).then(function () { return refreshCart(true); });
      return;
    }

    if (t.hasAttribute('data-qty-step')) {
      var input = t.parentElement.querySelector('input');
      var v = Math.max(1, (parseInt(input.value, 10) || 1) + Number(t.dataset.qtyStep));
      input.value = v;
    }
  });

  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });

  // Ajax add to cart
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches || !form.matches('form[action*="/cart/add"]')) return;
    if (!document.getElementById('cart-drawer')) return;
    e.preventDefault();
    var msg = form.querySelector('.msg');
    var btn = form.querySelector('[type=submit]');
    if (msg) msg.textContent = '';
    if (btn) btn.disabled = true;
    fetch('/cart/add.js', { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status && res.status !== 200) throw new Error(res.description || res.message || 'Could not add to cart');
        return refreshCart(true);
      })
      .catch(function (err) { if (msg) msg.textContent = err.message; })
      .then(function () { if (btn) btn.disabled = false; });
  });

  // Product page: gallery + variants
  document.addEventListener('click', function (e) {
    var th = e.target.closest('[data-thumb]');
    if (!th) return;
    var main = document.querySelector('[data-gallery-main]');
    if (!main) return;
    main.innerHTML = th.dataset.thumb;
    document.querySelectorAll('[data-thumb]').forEach(function (b) { b.setAttribute('aria-current', 'false'); });
    th.setAttribute('aria-current', 'true');
  });

  document.addEventListener('change', function (e) {
    var radio = e.target;
    if (!radio.matches || !radio.matches('.opt input')) return;
    var root = radio.closest('[data-product]');
    if (!root) return;
    var variants = JSON.parse(root.querySelector('[data-variants]').textContent);
    var chosen = Array.prototype.map.call(root.querySelectorAll('.opt'), function (fs) {
      var c = fs.querySelector('input:checked');
      return c ? c.value : null;
    });
    var match = variants.filter(function (v) {
      return v.options.every(function (o, i) { return o === chosen[i]; });
    })[0];
    var buy = root.querySelector('.js-buy');
    var price = root.querySelector('.js-price');
    var idInput = root.querySelector('input[name=id]');
    if (!match) {
      buy.disabled = true; buy.textContent = 'Unavailable';
      return;
    }
    idInput.value = match.id;
    history.replaceState(null, '', '?variant=' + match.id);
    fetch(root.dataset.url + '?variant=' + match.id + '&section_id=' + root.dataset.section)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var nb = doc.querySelector('.js-buy');
        var np = doc.querySelector('.js-price');
        if (nb) { buy.disabled = nb.disabled; buy.textContent = nb.textContent; }
        if (np) price.innerHTML = np.innerHTML;
      });
  });

  // ---- Menus, search overlay ----
  function closeAll() { body.classList.remove('menu-open', 'search-open', 'drawer-open'); }
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-menu-open],[data-menu-close],[data-search-open],[data-search-close],#mobile-menu a');
    if (!t) return;
    if (t.hasAttribute('data-menu-open')) { body.classList.add('menu-open'); return; }
    if (t.hasAttribute('data-menu-close') || t.matches('#mobile-menu a')) { body.classList.remove('menu-open'); return; }
    if (t.hasAttribute('data-search-open')) {
      body.classList.add('search-open');
      var inp = document.getElementById('header-search');
      if (inp) setTimeout(function () { inp.focus(); }, 150);
      return;
    }
    if (t.hasAttribute('data-search-close')) body.classList.remove('search-open');
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });

  // ---- Header: transparent at top, hides on scroll down, returns on scroll up ----
  var lastY = window.scrollY;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var ticking = false;

  function frame() {
    ticking = false;
    var y = window.scrollY;
    var wrap = document.getElementById('shopify-section-header');
    if (wrap) {
      wrap.classList.toggle('is-top', y < 20);
      if (y > 220 && y > lastY + 4) wrap.classList.add('is-hidden');
      else if (y < lastY - 4 || y <= 220) wrap.classList.remove('is-hidden');
    }
    lastY = y;

    // Stacked panels: each panel is covered by the next one as you scroll
    if (!reduce) {
      var panels = document.querySelectorAll('.panel');
      var vh = window.innerHeight;
      for (var i = 0; i < panels.length - 1; i++) {
        var top = panels[i + 1].getBoundingClientRect().top;
        var cover = Math.min(1, Math.max(0, 1 - top / vh));
        panels[i].style.setProperty('--cover', cover.toFixed(3));
      }
    }
  }
  function requestFrame() { if (!ticking) { ticking = true; window.requestAnimationFrame(frame); } }
  window.addEventListener('scroll', requestFrame, { passive: true });
  window.addEventListener('resize', requestFrame);
  frame();

  // ---- Reveal on scroll ----
  function initReveal() {
    var items = document.querySelectorAll('[data-reveal]:not(.is-in)');
    if (!('IntersectionObserver' in window) || reduce || (window.Shopify && window.Shopify.designMode)) {
      items.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
    items.forEach(function (el) { io.observe(el); });
  }
  initReveal();
  document.addEventListener('shopify:section:load', function () { initReveal(); frame(); });
})();
